import { useTranslation } from "react-i18next";
import { Item } from "../../../../../services/soap/dataObjects/Item";
import { Accordion, ActionButton, Disclosure, DisclosurePanel, DisclosureTitle, Divider, Flex, NumberField, Switch, TextField, View } from "@adobe/react-spectrum";
import { Check, ExclamationTriangle } from "react-bootstrap-icons";
import { useEffect, useRef, useState } from "react";
import ItemCurrencyDropDown from "../formComponents.tsx/itemCurrencyDropDown";
import ItemVatDropDown from "../formComponents.tsx/ItemVatDropDown";
interface IPricesSectionProps {
    data: Item;
    onChange: (data: Item) => void;
    validationErrors?: any
    expandedSectionKey?: any
    setExpandedSectionKey: (data: any) => void;
    setValidationErrors: (data: any) => void;
    fieldConfig?: any
    validationStatus?: any
    setValidationStatus: (data: any) => void;
}

const PricesSection: React.FC<IPricesSectionProps> = ({
    data,
    onChange,
    validationErrors,
    expandedSectionKey,
    setExpandedSectionKey,
    setValidationErrors,
    fieldConfig,
    validationStatus,
    setValidationStatus }) => {
    const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
    const [isSectionRequired, setIsSectionRequired] = useState(false);
    const [isCategoryRequired, setIsCategoryRequired] = useState(false);
    const inputRef = useRef<any>(null);
    useEffect(() => {
        if (expandedSectionKey?.has?.("pricesSection")) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 200);
        }
    }, [expandedSectionKey]);

    const handleSectionExpandedChange = () => {
        setExpandedSectionKey((prevKey: any) => prevKey.has("pricesSection") ? new Set() : new Set(["pricesSection"]));
    };

    const handleConfirm = () => {
        // const errors: any = {};
        // const name = data?.name?.trim?.() || '';
        // const type = data?.type?.trim?.() || '';
        // const status = data?.status?.trim?.() || '';
        // const category = data?.componentCategory?.trim?.() || '';
        // const units = data?.units?.trim?.() || '';
        // const producer = data?.manufacturer?.trim?.() || '';

        // if (name === '') {
        //     errors.nameError = _messages('product_name_required');
        // }
        // if (type === '') {
        //     errors.typeError = _messages('item_type_required');
        // }
        // if (status === '') {
        //     errors.statusError = _messages('item_status_required');
        // }
        // if (category === '' && isCategoryRequired) {
        //     errors.categoryError = _messages('item_category_required');
        // }
        // if (units === '') {
        //     errors.unitsError = _messages('item_unit_required');
        // }
        // if (producer === '') {
        //     errors.producerError = _messages('item_producer_required');
        // }
        // // setIsSectionRequired(name === '');

        // if (Object.keys(errors).length > 0) {
        //     setValidationErrors(errors);
        //     setValidationStatus((prev: any) => ({ ...prev, ['pricesSection']: false }));
        //     return;
        // }
        setValidationErrors({});
        setValidationStatus((prev: any) => ({ ...prev, ['pricesSection']: true }));
        setExpandedSectionKey(new Set(['componentSection']));
    };

    useEffect(() => {

    }, []);

    const verifyRequiredFields = () => {
        // const errors: any = {};
        // const name = data?.name?.trim?.() || '';
        // const type = data?.type?.trim?.() || '';
        // const status = data?.status?.trim?.() || '';
        // const category = data?.componentCategory?.trim?.() || '';
        // const units = data?.units?.trim?.() || '';
        // const producer = data?.manufacturer?.trim?.() || '';

        // if (name === '') {
        //     errors.nameError = '';
        // }
        // if (type === '') {
        //     errors.typeError = '';
        // }
        // if (status === '') {
        //     errors.statusError = '';
        // }
        // if (category === '' && isCategoryRequired) {
        //     errors.categoryError = '';
        // }
        // if (units === '') {
        //     errors.unitsError = '';
        // }
        // if (producer === '') {
        //     errors.producerError = '';
        // }

        // if (Object.keys(errors).length > 0) {
        //     setValidationStatus((prev: any) => ({ ...prev, ['pricesSection']: false }));
        //     return;
        // }
        // setValidationStatus((prev: any) => ({ ...prev, ['pricesSection']: true }));
    }

    const { t } = useTranslation('products');
    const _t = (key: string) => t(`addNewProduct.${key}`, { ns: 'products' });
    const _tt = (key: string) => t(`product_common.${key}`, { ns: 'products' });
    const _messages = (key: string) => t(`product_messages.${key}`, { ns: 'products' });



    return (
        <Accordion expandedKeys={expandedSectionKey} isQuiet onExpandedChange={() => handleSectionExpandedChange()}>
            <Disclosure id={"pricesSection"}>
                <DisclosureTitle>
                    <Flex justifyContent="space-between" alignItems="center" width="100%">
                        <View><span>{_t(`pricesSection`)}</span><span style={{ color: '#B0BEC5', fontFamily: 'Adobe Clean' }}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                        {validationStatus.pricesSection ? <Check size={20} color="#1976D2" /> : <ExclamationTriangle size={20} color="#FF9800" />}
                    </Flex>
                </DisclosureTitle>
                <DisclosurePanel>
                    <Divider size='M' UNSAFE_style={{ marginBottom: 5 }} />
                    <Flex direction={{ base: "column", L: 'column' }} gap="size-100" width="100%">
                        <Flex direction={{ base: "column", L: 'row' }} gap="size-100" width="100%">
                            <NumberField
                                label={_t("purchasePrice")}
                                ref={inputRef}
                                aria-label={_t('name')}
                                value={data?.purchasePrice ? +data?.purchasePrice : undefined}
                                onChange={(purchasePrice) => {
                                    onChange({ ...data, purchasePrice: purchasePrice ? purchasePrice?.toString() : '' });
                                    verifyRequiredFields();
                                }}
                                width={{base:"100%",L:'50%'}}
                            // isRequired
                            // errorMessage={validationErrors.nameError}
                            // validationState={validationErrors.nameError ? validationErrors.nameError !== '' ? 'invalid' : 'valid' : undefined}
                            />
                            <NumberField
                                label={_t("price")}
                                aria-label={_t('price')}
                                value={data?.amount ? +data?.amount : 0}
                                onChange={(salePrice) => {
                                    let amountWithVat = '';
                                    if (salePrice && !isNaN(salePrice)) {
                                        const vat = parseFloat(data.vatValue ? data.vatValue : '0');
                                        amountWithVat = (salePrice * (1 + vat / 100)).toFixed(2);
                                    }
                                    onChange({
                                        ...data,
                                        amount: salePrice ? salePrice.toString() : '',
                                        amountWithVat: salePrice ? amountWithVat : ''
                                    });
                                    verifyRequiredFields();
                                }}
                                width={{base:"100%",L:'50%'}}
                            />

                        </Flex>
                        <Flex direction={{ base: "column", L: 'row' }} gap="size-100" width="100%">
                            <ItemCurrencyDropDown selectedCurrency={data?.currency || ""}
                                onChange={(currency) => {
                                    onChange({ ...data, currency: currency ? currency.id.toString() : '' });
                                    verifyRequiredFields();
                                }}
                            />
                            <ItemVatDropDown selectedVat={data?.vat || ""} onChange={(vat) => {
                                const amountWithVat = data?.amount ? (+data.amount * (1 + (parseFloat(vat ? vat.value : '0') / 100))).toFixed(2) : '';
                                onChange({ ...data, vatValue: vat ? vat.value.toString() : '', vat: vat ? vat.id.toString() : '', amountWithVat });
                                verifyRequiredFields();
                            }}
                            />
                        </Flex>
                        <Flex direction={{ base: "column", L: 'row' }} gap="size-100" width="100%">
                            <NumberField
                                label={_t("quantity")}
                                aria-label={_t('quantity')}
                                value={data?.quantity ? +data?.quantity : undefined}
                                onChange={(qty) => {
                                    onChange({ ...data, quantity: qty ? qty?.toString() : '' });
                                    verifyRequiredFields();
                                }}
                                width={{base:"100%",L:'50%'}}
                            />
                            <NumberField
                                label={_t("includingVat")}
                                aria-label={_t('includingVat')}
                                value={data?.amountWithVat ? +data?.amountWithVat : 0}
                                onChange={(inclVat) => {
                                    let amount = '';
                                    if (inclVat && !isNaN(inclVat)) {
                                        const vat = parseFloat(data.vatValue ? data.vatValue : '0');
                                        amount = (inclVat / (1 + vat / 100)).toFixed(2);
                                    }
                                    onChange({
                                        ...data,
                                        amountWithVat: inclVat ? inclVat.toString() : '',
                                        amount: inclVat ? amount : ''
                                    });
                                    verifyRequiredFields();
                                }}
                                width={{base:"100%",L:'50%'}}
                            />
                        </Flex>
                        <Flex direction={{ base: "column", L: 'row' }} gap="size-100" width="100%">
                            <Switch isSelected={data.measureStock === "1" ? true : false} onChange={(isEnabled) => {
                                onChange({ ...data, measureStock: isEnabled ? '1' : '0' });
                                verifyRequiredFields()
                            }
                            }
                            >
                                {_t('measureStocks')}
                            </Switch>
                        </Flex>
                    </Flex>

                    <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
                        <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{ color: '#1976D2', padding: 10 }}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton>
                    </Flex>
                    <Divider size='M' UNSAFE_style={{ marginTop: 10 }} />
                </DisclosurePanel>
            </Disclosure>
        </Accordion>
    )

}

export default PricesSection;